import { useMediaQuery } from "@mui/material";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { schemesV2Api } from "../../services/schemesV2Api";

export default function CartTotal({ items, coinValueDiscount }) {
  const totalPrice = items
    .map((item) =>
      item.customization === "-1"
        ? parseFloat(item.price)
        : parseFloat(item.customization.variant[0].price)
    )
    .reduce((prev, curr) => prev + curr, 0);

  const [discountValue, setDiscountValue] = useState(0);
  const [discountName, setDiscountName] = useState(0);
  const [coinsApplied, setCoinsApplied] = useState(false);
  const [schemeDiscount, setSchemeDiscount] = useState(0);
  const [appliedSchemes, setAppliedSchemes] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const queryParams = new URLSearchParams(window.location.search);
        const coins = queryParams.get("coins");
        setCoinsApplied(coins);
        console.log(coinsApplied);

        const token = localStorage.getItem("token");
        if (!token) return;
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/v1.0.0/user/coupons/all.php?type=all_coupons`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (queryParams.get("discount") === "null") {
          setDiscountValue(0);
        } else {
          const selectedCouponData = data?.response?.filter(
            (item) => item.id === queryParams.get("discount")
          )[0];

          if (selectedCouponData) {
            setDiscountName(() => selectedCouponData.code);
            if (selectedCouponData.amount !== "0") {
              setDiscountValue(() => Number(selectedCouponData.amount));
            } else {
              setDiscountValue(
                () => totalPrice * (Number(selectedCouponData.percentage) / 100)
              );
            }
          }
        }

        // Fetch scheme benefits if schemeId and db_id are present
        const schemeId = queryParams.get("schemeId");
        const dbId = queryParams.get("db_id");
        
        if (schemeId && schemeId !== 'null' && schemeId !== 'undefined' && dbId && dbId !== 'null' && dbId !== 'undefined') {
          try {
            // Get product ID - handle both cart and buy-now scenarios
            let productId = 0;
            console.log("🔍 Scheme ID:", schemeId);
            console.log("🔍 DB ID (enrollment_id):", dbId);
            console.log("🔍 Items:", items);
            
            if (items && items.length > 0) {
              // For buy-now: items[0] has the product data directly
              // For cart: items[0] has cart_id and product data
              productId = items[0]?.id || items[0]?.product_id || 0;
            }

            console.log("🔍 Scheme Debug:", { schemeId, dbId, productId, items: items?.[0], itemsLength: items?.length });

            if (productId && productId > 0) {
              const userId = localStorage.getItem("user_id");
              const schemeResponse = await schemesV2Api.getSchemeBenefits(productId, userId);

              console.log("🔍 V2 Scheme API Response:", schemeResponse);
              console.log("🔍 Looking for enrollment_id:", dbId);
              console.log("🔍 Available schemes:", schemeResponse.response?.map(s => ({
                scheme_id: s.scheme_id,
                enrollment_id: s.enrollment_id,
                scheme_details_id: s.scheme_details?.id,
                scheme_name: s.scheme_details?.name,
                benefit: s.redeemable_amount
              })));

              if (schemeResponse.success && Array.isArray(schemeResponse.response)) {
                // Handle multiple schemes - split comma-separated values
                const dbIds = dbId.split(',');
                
                const schemesData = [];
                let totalSchemeDiscount = 0;
                let schemeNames = [];

                // Process each scheme
                for (let i = 0; i < dbIds.length; i++) {
                  const currentDbId = dbIds[i].trim();
                  
                  const schemeData = schemeResponse.response.find(
                    (scheme) => scheme.enrollment_id === currentDbId
                  );

                  console.log("🔍 Found Scheme Data by enrollment_id:", currentDbId, schemeData);

                  if (schemeData) {
                    const benefit = parseFloat(schemeData.redeemable_amount || "0");
                    const schemeName = schemeData.scheme_details?.name || "Scheme";
                    
                    schemesData.push({
                      enrollment_id: currentDbId,
                      name: schemeName,
                      benefit: benefit,
                      collection_amount: benefit // Collection amount is the same as benefit for now
                    });
                    
                    totalSchemeDiscount += benefit;
                    schemeNames.push(schemeName);
                    
                    console.log("🔍 Added Scheme:", { 
                      enrollment_id: currentDbId, 
                      name: schemeName, 
                      benefit, 
                      totalDiscount: totalSchemeDiscount 
                    });
                  } else {
                    console.log("🔍 No matching scheme found for enrollment_id:", currentDbId);
                  }
                }

                // Update state with multiple schemes
                setAppliedSchemes(schemesData);
                setSchemeDiscount(totalSchemeDiscount);
                
                console.log("🔍 Final Scheme Summary:", { 
                  schemesData, 
                  totalSchemeDiscount, 
                  schemeNames: schemeNames.join(', ') 
                });
              } else {
                console.log("🔍 API response not successful or empty:", schemeResponse);
              }
            } else {
              console.log("🔍 Cannot fetch scheme benefits - productId is invalid:", productId);
            }
          } catch (schemeErr) {
            console.log("fetching scheme benefits failed ", schemeErr);
          }
        }
      } catch (err) {
        console.log("fetching coupons failed ", err);
      }
    })();
  }, [discountValue, coinsApplied, items, totalPrice]);

  const matches = useMediaQuery("(min-width:600px)");

  return (
    <Box
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        marginTop: "3%",
      }}
    >
      <Card
        style={{
          width: matches ? "90%" : "",
          borderRadius: "10px",
          backgroundColor: "white",
          padding: "3%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-around",
          alignItems: "flex-start",
          marginBottom: "5%",
          textAlign: "left",
        }}
        elevation={1}
      >
        <Typography
          style={{
            textAlign: "left",
            fontWeight: "bold",
            color: "#505050",
            marginBottom: "1%",
            fontFamily: '"Roboto", sans-serif',
            fontSize: "1rem",
          }}
        >
          Order Summary
        </Typography>
        <Box
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            color: "gray",
          }}
        >
          <Typography
            style={{
              fontFamily: '"Roboto", sans-serif',
              fontSize: "0.8rem",
            }}
          >
            Subtotal:
          </Typography>
          <Typography
            style={{
              fontFamily: '"Roboto", sans-serif',
              fontSize: "0.8rem",
            }}
          >
            ₹ {Number(totalPrice).toLocaleString()}
          </Typography>
        </Box>
        <Box
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "1%",
            color: "gray",
          }}
        >
          <Typography
            style={{
              fontFamily: '"Roboto", sans-serif',
              fontSize: "0.8rem",
            }}
          >
            Discount: (
            <span
              style={{
                fontWeight: "bold",
              }}
            >
              {discountName}
            </span>
            )
          </Typography>
          <Typography
            style={{
              fontFamily: '"Roboto", sans-serif',
              fontSize: "0.8rem",
            }}
          >
            ₹ {Number(discountValue).toLocaleString()}
          </Typography>
        </Box>
        {coinsApplied ? (
          <Box
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "1%",
              color: "gray",
            }}
          >
            <Typography
              style={{
                fontFamily: '"Roboto", sans-serif',
                fontSize: "0.8rem",
              }}
            >
              Redeemed Coins:
            </Typography>
            <Typography
              style={{
                fontFamily: '"Roboto", sans-serif',
                fontSize: "0.8rem",
              }}
            >
              ₹ {Number(coinsApplied).toLocaleString()}
            </Typography>
          </Box>
        ) : null}
        {schemeDiscount > 0 ? (
          <Box
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "1%",
              color: "gray",
            }}
          >
            <Typography
              style={{
                fontFamily: '"Roboto", sans-serif',
                fontSize: "0.8rem",
              }}
            >
              Scheme Discount:
            </Typography>
            <Typography
              style={{
                fontFamily: '"Roboto", sans-serif',
                fontSize: "0.8rem",
                color: "#2e7d32",
              }}
            >
              - ₹ {Number(schemeDiscount).toLocaleString()}
            </Typography>
          </Box>
        ) : null}
        <Box
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            color: "#050505",
            marginTop: "1%",
          }}
        >
          <Typography
            style={{
              fontFamily: '"Roboto", sans-serif',
              fontSize: "1rem",
              fontWeight: "bold",
            }}
          >
            Total:
          </Typography>
          <Typography
            style={{
              fontFamily: '"Roboto", sans-serif',
              fontSize: "1rem",
              fontWeight: "bold",
            }}
          >
            ₹
            {(
              Number(totalPrice) -
              discountValue -
              (coinsApplied ? coinsApplied : 0) -
              schemeDiscount
            ).toLocaleString()}
          </Typography>
        </Box>
      </Card>
    </Box>
  );
}
